import { AttributeTypeEnum } from "@c2b/muven-commons";

export class AttributeModel {
    id?: string;
    name: string = "";
    required: boolean = false;
    type!: AttributeTypeEnum;

    constructor(a?: Partial<AttributeModel>) {
        Object.assign(this, a);
    }

    isGrid():boolean {
        return this.type === AttributeTypeEnum.Grid;
    }
}
